import { ConversationQueryVariables } from '../generated/graphql';

export const conversationKeys = {
  base: ['conversation'],
  numberOfUnreadConversations: () => [...conversationKeys.base, 'numberOfUnreadConversations'],
  conversations: () => [...conversationKeys.base, 'conversations'],
  conversation: (vars: ConversationQueryVariables) => [...conversationKeys.base, vars, 'conversation'],
};
